import { isMobile } from "react-device-detect";
import { DropDown } from "../DropDown/DropDown";
import { WidgetChangeEnv } from "../Widgets/WidgetChangeEnv";

export const ChangeEnvironment = ({ itemsStateObj, matchesBreakPoint }) => {
  return isMobile || matchesBreakPoint ? <WidgetChangeEnv itemsStateObj={itemsStateObj} /> : <DropDown itemsStateObj={itemsStateObj} />;
};
